import React, { useState } from 'react';
import Container from '../Container/Index';
import Title from '../Title/Index';
import ImageTag from '../Image/index';

const Chairperson = ({Data}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <Container _parentClass={'m-0 leaderSection overflow-hidden'}>
      <Title firstHeading={'Our Visionary Leader'} />

      <div className='chairpersonRow'>
        <div className='chairpersonImage'>
          <div
            className='chairpersonProfile'
            data-aos='flip-left'
            data-aos-offset='100'
            data-aos-duration='500'
            data-aos-once='true'
            data-aos-easing='ease-in-sine'
          >
            <ImageTag ImagePath={Data.image} ImageAlt={Data.name} />
          </div>

          <div
            className='namePlate'
            data-aos='fade-in'
            data-aos-offset='100'
            data-aos-duration='600'
            data-aos-once='true'
            data-aos-easing='ease-in-sine'
          >
            <p><em>{Data.name}</em></p>
            <p>{Data.title}</p>
          </div>
        </div>

        <div className='chairpersonContent'>
          {Data.intro.map((para, index) => (
            <p
              key={index}
              data-aos='fade-up'
              data-aos-offset='100'
              data-aos-duration='500'
              data-aos-once='true'
              data-aos-easing='ease-in-sine'
            >
              {para}
            </p>
          ))}

          {isExpanded &&
            Data.more.map((para, index) => (
              <p
                key={`more-${index}`}
                data-aos='fade-up'
                data-aos-offset='100'
                data-aos-duration='500'
                data-aos-once='true'
                data-aos-easing='ease-in-sine'
              >
               {para}
              </p>
            ))}

          <span onClick={toggleReadMore} className='mt-2 text-blue-600 hover:underline cursor-pointer'>
            {isExpanded ? 'Read Less' : 'Read More...'}
          </span>

          <p
            className='quoteContent'
            data-aos='fade-up'
            data-aos-offset='100'
            data-aos-duration='500'
            data-aos-once='true'
            data-aos-easing='ease-in-sine'
          >
            {Data.quote}
          </p>
        </div>
      </div>
    </Container>
  );
};

export default Chairperson;
